import { useMemo, useState } from 'react';

export default function useExpiryEditor(initial = ['']) {
  const [expiryList, setExpiryList] = useState(initial);
  const [showExpiryModal, setShowExpiryModal] = useState(false);
  const todayStr = useMemo(() => new Date().toISOString().split('T')[0], []);

  const formatDateDMY = (yyyyMmDd) => {
    const s = String(yyyyMmDd || '').trim();
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return s;
    return `${m[3]}/${m[2]}/${m[1]}`;
  };

  const expiryDisplay = useMemo(
    () => expiryList.filter(Boolean).map(formatDateDMY).join(' / ') || '-',
    [expiryList]
  );

  const updateExpiryAt = (idx, val) => setExpiryList(prev => prev.map((v, i) => (i === idx ? val : v)));
  const removeExpiryAt = idx => setExpiryList(prev => prev.filter((_, i) => i !== idx));

  const setCount = n => {
    const nextLen = Math.max(1, Number(n) || 1);
    setExpiryList(prev => {
      if (nextLen === prev.length) return prev;
      if (nextLen > prev.length) return [...prev, ...Array(nextLen - prev.length).fill('')];
      return prev.slice(0, nextLen);
    });
  };

  return {
    expiryList,
    setExpiryList,
    showExpiryModal,
    setShowExpiryModal,
    todayStr,
    expiryDisplay,
    updateExpiryAt,
    removeExpiryAt,
    setCount,
  };
}
